module.exports = "/fonts/vendor/material-icons/iconmaterial-icons.woff?4d73cb90e394b34b767077d75cce0c4c";